export default __webpack_public_path__ + "static/media/83t.9fc0b467.jpg";